<template>
  <div>
    <el-row style="background-color:#fff;padding:20px;margin:1px 20px 10px 1px;box-shadow:1px 1px 3px #ddd;">
      <el-row v-show="!isOpenStatsBox">
        <w-eventlevel-count-box :active="active" @click-open-stats-box-button="clickOpenStatsBoxButton" />
      </el-row>
      <el-row v-show="isOpenStatsBox" :gutter="10" height:250px>
        <el-col :span="6">
          <w-event-hist-pie-chart ref="eventlevelPieChart" title="이벤트 등급 건수" :active="active" chart-type="eventlevel"
          :current-filter-count="currentFilterCount" @set-event-hist-filter="setEventHistFilter" />
        </el-col>
        <el-col :span="6">
          <w-event-hist-pie-chart ref="objDefinePieChart" title="관리구분 건수" :active="active" chart-type="objDefine"
          :current-filter-count="currentFilterCount" @set-event-hist-filter="setEventHistFilter" />
        </el-col>
        <el-col :span="12">
          <w-event-top-box ref="eventTopBox" :active="active" :current-filter-count="currentFilterCount" :filter-list="filterList"
          @set-event-hist-filter="setEventHistFilter" @click-open-stats-box-button="clickOpenStatsBoxButton"/>
        </el-col>
      </el-row>
    </el-row>
    <el-row style="min-height:calc(100vh - 447px);background-color:#fff;padding:20px;margin:1px 20px 20px 1px;box-shadow:1px 1px 3px #ddd">
      <el-row class="mr-b10">
        <w-event-hist-filter-box ref="eventHistFilterBox" @delete-event-hist-filter="deleteEventHistFilter" @set-event-hist-filter="setEventHistFilter"
        @change-filter-list="changeFilterList"/>
      </el-row>
      <el-row  class="mr-b10">
        <w-event-hist-stacked-column-chart style="height:150px" :active="active" :filter-params="filterParams" />
      </el-row>
      <w-event-common-table eventType="hist" ref="eventCommonTableRef" :active="active" :filter-params="filterParams"></w-event-common-table>
    </el-row>
  </div>
</template>

<script>
import { isNil, map } from 'lodash';
import WEventCommonTable from '@/views/event/components/EventCommonTable';
import WEventHistStackedColumnChart from '@/views/event/event-hist/components/EventHistStackedColumnChart';
import WEventHistPieChart from './components/EventHistPieChart';
import WEventHistFilterBox from './components/EventHistFilterBox';
import WEventlevelCountBox from './components/EventlevelCountBox';
import WEventTopBox from './components/EventTopBox';

export default {
  name: 'WEventHist',
  components: {
    WEventCommonTable,
    WEventHistStackedColumnChart,
    WEventHistPieChart,
    WEventHistFilterBox,
    WEventlevelCountBox,
    WEventTopBox,
  },
  props: {
    active: Boolean,
  },
  data() {
    return {
      isOpenStatsBox: true,
      // 필터의 갯수가 10개 넘으면 필터 추가를 막기위해 사용
      currentFilterCount: 0,
      filterList: [],
      filterParams: {},
    };
  },
  watch: {
    active: {
      handler(value) {
        if (value) {
          this.$store.dispatch('setSelectedEvents', []);
        }
      },
    },
  },
  methods: {
    map,
    loadData() {
      this.$refs.eventCommonTableRef.loadData();
    },
    setEventHistFilter(filter) {
      this.$refs.eventHistFilterBox.setEventHistFilter(filter);
    },
    deleteEventHistFilter(filter) {
      if (isNil(filter)) {
        this.$refs.eventlevelPieChart.deleteEventHistFilter(filter);
        this.$refs.objDefinePieChart.deleteEventHistFilter(filter);
        this.$refs.eventTopBox.deleteEventHistFilter(filter);
        return;
      }
      if (filter.type === 'eventlevel') {
        this.$refs.eventlevelPieChart.deleteEventHistFilter(filter);
      } else if (filter.type === 'objDefine') {
        this.$refs.objDefinePieChart.deleteEventHistFilter(filter);
      } else if (filter.type === 'obj' || filter.type === 'rsc') {
        this.$refs.eventTopBox.deleteEventHistFilter(filter);
      }
    },
    clickOpenStatsBoxButton() {
      this.isOpenStatsBox = !this.isOpenStatsBox;
    },
    changeFilterList(filterList) {
      const filterParams = {
        eventlevelIds: [],
        objDefineIds: [],
        objIds: [],
        rscMixKeys: [],
      };
      filterList.forEach((item) => {
        if (item.type === 'eventlevel') {
          filterParams.eventlevelIds.push(item.eventlevelId);
        } else if (item.type === 'objDefine') {
          filterParams.objDefineIds.push(item.objDefineId);
        } else if (item.type === 'obj') {
          filterParams.objIds.push(item.objId);
        } else if (item.type === 'rsc') {
          filterParams.rscMixKeys.push(item.rscMixKey);
        }
      });
      this.filterParams = filterParams;
      this.filterList = filterList;
      this.currentFilterCount = filterList.length;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/event/event-hist/index.vue